export const roundNearest5 = (num: number) => {
    const roundedValue = Math.round(num / 5) * 5

    return roundedValue || Math.round(num)
}
